import { cn } from "@/lib/utils";
import { formatPolicySubstatusLabel, isPolicySubstatus } from "@shared/policy-substatus";

interface Props {
  substatus?: string | null;
  className?: string;
  "data-testid"?: string;
}

// CSR-2336 — the substatus line rendered directly below a main status badge.
export function PolicySubstatusText({ substatus, className, ...rest }: Props) {
  if (!isPolicySubstatus(substatus)) return null;
  return (
    <span
      className={cn("block text-xs font-medium text-amber-700", className)}
      data-testid={rest["data-testid"] ?? `policy-substatus-${substatus}`}
    >
      {formatPolicySubstatusLabel(substatus)}
    </span>
  );
}
